(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 769px)');
  var SCROLL_THRESHOLD = 100;

  function getThemesScript() {
    return document.querySelector('[id^="home-banner-header-themes-"]');
  }

  function parseThemes() {
    var script = getThemesScript();
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function HomeBannerHeaderSync() {
    this.headerNav = document.querySelector('header-navigation[data-is-index]');
    if (!this.headerNav) return;

    this.themes = parseThemes();
    if (!this.themes.length) return;

    this.container = this.headerNav.querySelector('.header-v2--container');
    this.logoImg = this.headerNav.querySelector('.header-logo-img');
    this.defaultLogo =
      this.headerNav.dataset.defaultLogo ||
      (this.logoImg && this.logoImg.getAttribute('src')) ||
      '';
    this.defaultFontColor =
      this.headerNav.dataset.defaultFontColor ||
      getComputedStyle(this.headerNav).getPropertyValue('--default-header-font-color').trim() ||
      '#ffffff';

    this.currentIndex = 0;
    this.boundSwiper = null;

    this.onSwiperReady = this.onSwiperReady.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);
    this.onScrollOrResize = this.onScrollOrResize.bind(this);

    document.addEventListener('swiper-component:ready', this.onSwiperReady);
    window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
    DESKTOP_MQ.addEventListener('change', this.onScrollOrResize);

    this.bindExistingSwiper();
    this.applyForCurrentState();
  }

  HomeBannerHeaderSync.prototype.bindExistingSwiper = function () {
    var swiperComponent = document.querySelector('swiper-component.section-home-banner-swiper');
    if (!swiperComponent || !swiperComponent.swiper) return;

    if (this.boundSwiper) {
      this.boundSwiper.off('slideChange', this.onSlideChange);
    }

    this.boundSwiper = swiperComponent.swiper;
    this.currentIndex = this.boundSwiper.realIndex;
    this.boundSwiper.on('slideChange', this.onSlideChange);
  };

  HomeBannerHeaderSync.prototype.isFloatingDesktop = function () {
    return (
      DESKTOP_MQ.matches &&
      this.container &&
      this.container.classList.contains('is--index') &&
      window.scrollY <= SCROLL_THRESHOLD
    );
  };

  HomeBannerHeaderSync.prototype.resolveTheme = function (index) {
    var theme = this.themes[index] || {};
    return {
      logo: theme.logo || this.defaultLogo,
      fontColor: theme.fontColor || this.defaultFontColor,
    };
  };

  HomeBannerHeaderSync.prototype.applyTheme = function (index) {
    if (!this.isFloatingDesktop()) {
      this.restoreDefaults();
      return;
    }

    var theme = this.resolveTheme(index);
    if (this.logoImg && theme.logo) {
      this.logoImg.src = theme.logo;
    }
    this.headerNav.style.setProperty('--default-header-font-color', theme.fontColor);
  };

  HomeBannerHeaderSync.prototype.restoreDefaults = function () {
    if (this.logoImg && this.defaultLogo) {
      this.logoImg.src = this.defaultLogo;
    }
    this.headerNav.style.setProperty('--default-header-font-color', this.defaultFontColor);
  };

  HomeBannerHeaderSync.prototype.applyForCurrentState = function () {
    this.applyTheme(this.currentIndex);
  };

  HomeBannerHeaderSync.prototype.onScrollOrResize = function () {
    this.applyForCurrentState();
  };

  HomeBannerHeaderSync.prototype.onSlideChange = function () {
    if (!this.boundSwiper) return;
    this.currentIndex = this.boundSwiper.realIndex;
    this.applyForCurrentState();
  };

  HomeBannerHeaderSync.prototype.onSwiperReady = function (event) {
    var swiperComponent = event.detail && event.detail.swiperComponent;
    if (!swiperComponent || !swiperComponent.classList.contains('section-home-banner-swiper')) {
      return;
    }

    if (this.boundSwiper) {
      this.boundSwiper.off('slideChange', this.onSlideChange);
    }

    this.boundSwiper = event.detail.swiper;
    this.currentIndex = this.boundSwiper.realIndex;
    this.boundSwiper.on('slideChange', this.onSlideChange);
    this.applyForCurrentState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new HomeBannerHeaderSync();
    });
  } else {
    new HomeBannerHeaderSync();
  }
})();
